<script>
    import { cart } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/cart.js?1733898724834';
    import MiniCart from '/srv/web/wyvr/html/releases/58819/gen/client/shop/cart/MiniCart.svelte?1733898724834';
    import Badge from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Badge.svelte?1733898724834';
    import { onMount } from 'svelte';

    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }

    export let locale;
    export let currency;

    $: count = get_count($cart);

    ;

    onMount(() => {
        // KW-983 - Add to cart event can be used like this: trigger("addToCart:ab", {"sku": "<sku>", "qty": <qty_or_1_when_not_set})
        const event = 'addToCart:ab';
        on(event, (data) => {
            if(!data) {
                console.error(event, 'missing data');
                return;
            }
            const { sku, qty } = data;
            if(!sku) {
                console.error(event, 'missing sku');
                return;
            }
            cart.update_item(sku, qty || 1);
        });
    });

    function get_count(cart) {
        if (!cart || !cart.items) {
            return 0;
        }
        return Object.values(cart.items).reduce(
            (acc, item) => acc + item.qty,
            0
        );
    }
</script>

<section>
    <div class="m-cart m-navigation__item">
        <label for="cart-toggle">
            <span class="m-navigation__link cart__button">
                <span class="m-navigation__menu-text">
                    <i class="icon-cart" />
                    <span>{window.__('cart.name_header')}</span>
                    {#if count >= 1}
                        <Badge>{count}</Badge>
                    {/if}
                </span>
            </span>
        </label>
        <input type="checkbox" id="cart-toggle" />
        <div class="cart">
            <label class="cart" for="cart-toggle">{window.__('shop.close')}</label>

            <MiniCart {locale} {currency} />
        </div>
    </div>
</section>


<style>
    section {
        position: relative;
    }
    label:hover {
        background-color: #eeeeee;
    }

    .icon-cart {
        font-family: 'kofferworld';
        speak: never;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        margin-bottom: 10px;
        display: block;
        font-size: 20px;
        text-align: center;
    }

    label {
        color: var(--color-primary);
        padding: 8px 16px;
        cursor: pointer;
        color: var(--darkgray);
        text-decoration: none;
        webkit-transition: 0.5s ease-in-out !important;
        transition: 0.5s ease-in-out !important;
        display: inline-block;
    }

    @media (max-width: 992px) {
        .m-navigation__menu-text > span {
            font-size: 0.65rem !important;
            white-space: nowrap;
        }
        label {
            padding: 5px !important;
        }
    }

    /* cart dropdown item */
    input {
        position: fixed !important;
        appearance: none !important;
        background: transparent;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 500;
        border: 0;
        padding: 0;
        margin: 0;
        pointer-events: none;
        cursor: pointer;
    }

    input:checked {
        background: rgba(0, 0, 0, var(--opacity-backdrop));
        pointer-events: all;
    }

    #cart-toggle:checked {
        cursor: pointer !important;
        background: rgba(0, 0, 0, 0.1) !important;
    }

    .cart {
        position: absolute;
        top: 100%;
        right: 0;
        z-index: 1001 !important;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        max-width: 500px;
        width: 90vw;
        max-height: 90vh;
        background: var(--lightbrown);
        opacity: 0;
        padding: 1rem 1rem 0 1rem;
        -webkit-box-shadow: 0 5px 10px 1px rgba(119, 119, 199, 0.15);
        box-shadow: 0 5px 10px 1px rgba(119, 119, 199, 0.15);
        cursor: default;
        pointer-events: none;
        -webkit-transform: translateY(-5px);
        transform: translateY(-5px);
        -webkit-transition: opacity 0.1s linear, -webkit-transform 0.1s ease-out;
        transition: opacity 0.1s linear, -webkit-transform 0.1s ease-out;
        transition: transform 0.1s ease-out, opacity 0.1s linear;
        transition: transform 0.1s ease-out, opacity 0.1s linear,
            -webkit-transform 0.1s ease-out;

        @media (min-height: 1024px) {
            padding: 2rem 1.25rem 1.25rem 1.25rem;
        }
    }

    input:checked + .cart {
        pointer-events: all;
        opacity: 1;
        transform: none;
    }

    .m-navigation__menu-text {
        padding-left: 0;
        padding-right: 0;
    }

    .m-navigation__menu-text span {
        font-size: var(--h6__font-size-desktop);
        font-weight: var(--h6__font-weight);
        line-height: var(--h6__line-height);
        color: var(--h6__color);
        margin: var(--h6__margin);
        text-transform: none;
    }

    @media (max-width: 992px) {
        .m-navigation__menu-text span {
            font-size: 0.65rem !important;
        }
    }
</style>